const PS_UALARMS = {
    "UA01": "ua01_alarm",
    "UA02": "ua02_alarm",
    "UA03": "ua03_alarm",
    "UA04": "ua04_alarm",
}

const PS_ALARMS = {
    "A01": "line_voltage_fail",
    "A02": "phase_loss",
    "A03": "phase_sequence_error",
    "A04": "freq_out_of_range",
    "A05": "aux_voltage_fail",
    "A06": "asymmetric_current",
    "A07": "overcurrent_protection",
    "A08": "blocked_rotor",
    "A09": "low_load",
    "A10": "long_startup",
    "A11": "bypass_relay_fail",
    "A12": "thermal_pre_alarm_motor",
    "A13": "thermal_pre_alarm_starter",
    "A14": "thermal_prot_motor",
    "A15": "thermal_prot_starter",
    "A16": "short_circuit_l1t1",
    "A17": "short_circuit_l3t3",
    "A18": "temp_sensor_fail",
    "A19": "low_line_voltage",
    "A20": "high_line_voltage",
    "A21": "low_motor_current",
    "A22": "maintenance_request",
    "A23": "fan_fail",
    "A24": "blocked_fan",
    "A25": "system_error",
}

export const ALARMAS_PS = {
  ...PS_ALARMS,
  ...PS_UALARMS,
}

// const PS_UALARMS = {
//     "UA01": "ALARMA 1 DE USUARIO",
//     "UA02": "ALARMA 2 DE USUARIO",
//     "UA03": "ALARMA 3 DE USUARIO",
//     "UA04": "ALARMA 4 DE USUARIO"
// }


// const PS_ALARMS = {
//     "A01": "FALLO DE TENSIÓN DE LÍNEA",
//     "A02": "PÉRDIDA FASE",
//     "A03": "ERROR DE SECUENCIA DE FASES",
//     "A04": "FREC. FUERA DE LÍMITES",
//     "A05": "FALLO DE TENSIÓN AUX.",
//     "A06": "CORRIENTE ASIMÉTRICA",
//     "A07": "PROT. SOBRECORRIENTE",
//     "A08": "ROTOR BLOQUEADO",
//     "A09": "CARGA DEMASIADO BAJA",
//     "A10": "ARRANQ. DEMASIADO LARGO",
//     "A11": "AVERÍA DE RELÉ DE BYPASS",
//     "A12": "PREAL. TÉRMICA MOT.",
//     "A13": "PREAL. TÉRMICA ARR.",
//     "A14": "PROT. TÉRMICA MOTOR",
//     "A15": "PROT. TÉRMICA ARR.",
//     "A16": "FASE L1-T1 EN CORTOCIRCUITO",
//     "A17": "CORTOCIRCUITO EN FASE L3-T3",
//     "A18": "AVERÍA DE SENSOR TEMP.",
//     "A19": "TENSIÓN DE LÍNEA BAJA",
//     "A20": "TENSIÓN DE LÍNEA ALTA",
//     "A21": "CORRIENTE MOT. BAJA",
//     "A22": "SOLIC. MANTENIMIENTO",
//     "A23": "FALLO DE VENTILADORES",
//     "A24": "VENTILADOR BLOQUEADO",
//     "A25": "ERROR DE SISTEMA",
// }

// export const ALARMAS_PS = {
//   ...PS_ALARMS,
//   ...PS_UALARMS, 
// }